import styled from 'styled-components';
import type { InterstateTheme } from '@interstate/components/InterstateThemeProvider';

export const StyledMandatoryDetailsCard = styled.div<{ interstateTheme: InterstateTheme }>`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 16px;
    border-radius: 4px;
    border: 1px solid ${({ interstateTheme }) => interstateTheme.tokens.SemColorBorderMuted};
    background: ${({ interstateTheme }) => interstateTheme.tokens.SemColorSurfaceApp};
    margin-bottom: 20px;
`;

export const StyledFormGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
`;

export const StyledFullRow = styled.div`
    grid-column: 1 / -1;
`;

export const StyledButtonWrapper = styled.div`
    display: flex;
    justify-content: stretch;

    & > button {
        width: 100%;
    }
`;

export const accordionSx = {
    borderBottom: 'none',
    margin: 0,
    '& .MuiAccordionSummary-root': {
        paddingTop: 0,
        paddingBottom: 0,
        gap: '8px',
        minHeight: 'auto',
        '&.Mui-expanded': { minHeight: 'auto' }
    }
};
